import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import Box, { BoxProps } from '@classify/react-core-components/Box';
import Narrative from '@classify/react-marketing-components/Narrative';
import Typography from '@classify/react-core-components/Typography';
export interface Props extends BoxProps {
  media: ReactNode;
  isMediaBottomAligned?: boolean;
  hasLargeContent?: boolean;
  tagline?: string;
  taglineColor?: string;
  textHighlightColor?: string;
  title?: string;
  titleColor?: string;
  subheading?: string;
  subheadingColor?: string;
  children?: ReactNode;
}
const Hero = t0 => {
  const $ = _c(37);
  const {
    media,
    isMediaBottomAligned,
    hasLargeContent,
    tagline,
    title,
    subheading,
    children,
    taglineColor,
    titleColor,
    subheadingColor,
    textHighlightColor
  } = t0;
  const mediaVerticalAlignment = isMediaBottomAligned ? "flex-end" : "center";
  const componentMobilePaddingBottom = isMediaBottomAligned ? 0 : 4;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      xs: "100%",
      md: "auto"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== mediaVerticalAlignment) {
    t2 = {
      md: mediaVerticalAlignment
    };
    $[1] = mediaVerticalAlignment;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== hasLargeContent) {
    t3 = hasLargeContent && {
      maxWidth: {
        lg: 468
      }
    };
    $[3] = hasLargeContent;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = {
      width: t1,
      alignSelf: t2,
      ...t3
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== media || $[9] !== t4) {
    t5 = <Box data-testid="hero-media-wrapper" sx={t4}>{media}</Box>;
    $[8] = media;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      md: 400
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== componentMobilePaddingBottom) {
    t7 = {
      gap: 4,
      minHeight: t6,
      paddingRight: 0,
      paddingLeft: 0,
      paddingBottom: {
        xs: componentMobilePaddingBottom,
        md: 0
      }
    };
    $[12] = componentMobilePaddingBottom;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      mb: 2
    };
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== tagline || $[16] !== taglineColor) {
    t9 = tagline && <Typography component="span" variant="overline" sx={{
      ...(taglineColor && {
        color: taglineColor
      })
    }}>{tagline}</Typography>;
    $[15] = tagline;
    $[16] = taglineColor;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== textHighlightColor || $[19] !== title || $[20] !== titleColor) {
    t10 = title && <Typography dangerouslySetInnerHTML={{
      __html: title
    }} sx={{
      color: titleColor || "text.onMainSecondary",
      marginBottom: 2,
      marginTop: {
        xs: 2,
        md: 0
      },
      "> strong": {
        color: textHighlightColor ?? "brand.main"
      }
    }} variant="h1" />;
    $[18] = textHighlightColor;
    $[19] = title;
    $[20] = titleColor;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== children || $[23] !== subheading || $[24] !== subheadingColor) {
    t11 = subheading && <Typography sx={{
      ...(children && {
        marginBottom: 2
      }),
      ...(subheadingColor && {
        color: subheadingColor
      }),
      maxInlineSize: 768
    }} component="p" variant="subtitle1">{subheading}</Typography>;
    $[22] = children;
    $[23] = subheading;
    $[24] = subheadingColor;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== children) {
    t12 = children && <Box>{children}</Box>;
    $[26] = children;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t10 || $[29] !== t11 || $[30] !== t12 || $[31] !== t9) {
    t13 = <Box sx={t8}>{t9}{t10}{t11}{t12}</Box>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
    $[31] = t9;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t13 || $[34] !== t5 || $[35] !== t7) {
    t14 = <Narrative media={t5} sx={t7}>{t13}</Narrative>;
    $[33] = t13;
    $[34] = t5;
    $[35] = t7;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  return t14;
};
export default Hero;